import Typography from '@mui/material/Typography';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';

interface EmptyContextualHelpListTable {
  onClose: () => void;
}

export const EmptyContextualHelpListTable: React.FC<EmptyContextualHelpListTable> = ({ onClose }) => {
  return (
    <div
      style={{
        height: '85%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          width: '385px',
        }}
      >
        <CampaignOutlinedIcon style={{ color: '#BCBEDC', width: '70px', height: '70px', margin: '20px' }} />
        <Typography fontSize={18} color={'#3C419A'} fontWeight={'700'}>
          W tej chwili nie została dodana żadna pomoc kontekstowa.
        </Typography>
      </div>
    </div>
  );
};
